import ModelUser from '@models/user'
import { getServerParam } from '@constants'

export default {
  namespaced: true,

  state: {
    isLogin: false,
    user: null,
    isVoted: false,
    voteKey: null,
    apiKey: null,
    resetTime: null,
  },

  getters: {
    isLogin(state) {
      return state.isLogin
    },
    user(state) {
      return state.user
    },
    isVoted(state) {
      return state.isVoted
    },
    voteKey(state) {
      return state.voteKey
    },
    apiKey(state) {
      return state.apiKey
    },
    resetTime(state) {
      return state.resetTime
    }
  },

  mutations: {
    setLoginState(state, bool){
      state.isLogin = bool
    },
    setUser(state, user) {
      state.user = new ModelUser(user)
    },
    setVoteState(state, bool) {
      state.isVoted = bool
    },
    setVoteKey(state, voteKey){
      state.voteKey = voteKey
    },
    setApiKey(state, apiKey){
      state.apiKey = apiKey
    },
    setResetTime(state) {
      let now = new Date()
      const resetTime = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 11, 59, 59)
      state.resetTime = resetTime.toJSON()
    },
  },

  actions: {
    init({ commit }) {

      let config = getServerParam()

      commit('setLoginState', !!config.user)
      if (config.user) {
        commit('setUser', config.user)
      }
      if (config.isVoted) {
        commit('setVoteState', !!config.isVoted)
      }
      if (config.vote_key) {
        commit('setVoteKey', config.vote_key)
      }
      if (config.api_key) {
        commit('setApiKey', config.api_key)
      }
    },
  }

}
